import {strToInt, debounce, getShareToken, objToStr} from '@/utils/sysUtils.js'
import {delDoc,docRename,getUserDir,changeDir,addDocShare} from '@/api/api.js';
import {generateTree} from '@/utils/sysData.js'
import config from '@/config/index.js'


export default {
    created(){
    },
    data() {
        return {
            menuData:[{id:'rename',name:'重命名'},{id:'remove',name:'移动'},{id:'delete',name:'删除'}],   //菜单数据 
            
        }
    },
    methods: {
        share(record) {
            console.log("record====", record)
            if (record.type == 1) {
                this.$showToast({msg: '请分享单个文件！' });
                return false;
            }
            let data = {
                "docId": record.id, 
                "fileId": record.fileId,
                "code": getShareToken(12), 
                "userId": sessionStorage.getItem("userId"),
                "openShare":1,
                "wantPassword":0,
                "pwCode": getShareToken(6), 
                "openDays":0,
                "days":1,
                "openTimes":0,
                "times": 1,
                "canComment": 1
            }
            data.shareUrl = config.configData.web_url + "/d/" + this.shareData.code;
            this.$showLoading();
            addDocShare(data).then((res)=>{
                this.$closeLoading();
                if (res.data.success == true) {
                    console.log(res.data.result);
                    this.shareData = res.data.result;
                    this.shareData.shareUrl = config.configData.web_url + "/d/" + this.shareData.code;
                    this.shareData.copyText = record.name + ", 地址: " + config.configData.web_url + "/d/" + this.shareData.code + "    密码：" + this.shareData.pwCode;
                    this.showShare = true;
                    return;
                } else {
                    this.$showToast({msg: res.data.message});
                    return;                       
                }
            })
        },
        menuClick(id) {
            if (id == 'rename') {
                this.$showInputBox({
                    caption:"提示",
                    inputValue: this.selectName,
                    callback:(data) => {
                        docRename(this.selectId, data).then((res) => {
                            if (res.data.success == true) {
                                this.$closeInputBox();
                                this.$emit("change")
                            }
                        });
                    }
                })
            }
            else if (id == 'remove') {
                getUserDir().then((res) => {
                    if (res.data.success == true) {
                        let data = res.data.result.records;
                        let children = generateTree(data, "0", 2);
                        this.dirData = [{"id":0, "name":"个人空间", "level": 1, "children": children}];
                        this.showMove = true;
                    }
                })
            }
            else if (id == 'delete') {
                this.$showMsgBox({
                    caption:"询问",
                    msg: '确定要删除该条记录吗？',
                    callback:(data) => {
                        if (data == "yes") {
                            delDoc(this.selectId).then((res) => {
                                if (res.data.success == true) {
                                    this.$emit("change")
                                    return;
                                } else {
                                    this.$showToast({msg: res.data.message});
                                    return;                       
                                }
                            })
                        } 
                    }
                })
            } else {
                this.$showToast({                   
                    msg: "您点击了：" + id,
                    duration: 2000
                })
            }
        }, 
        async dirChange(dirId) {

            if (this.batchMove) {
                let selected = this.fileData.filter(d=>d.select == true);
                let i = 0;
                selected.forEach(async item => {
                    await changeDir(item.id, dirId).then((res) => {
                        if (res.data.success == true) {   
                            i++;
                        } 
                    })
                });

                this.dirBoxClassName = "dir-box";
                this.selectBoxClassName = "select-box";     
                this.fileData.forEach((i,index) => {
                    i.select = false;
                }) 
                this.editMode = false;    
                this.showMove = false;   
                this.$showToast({msg: '操作成功！' });     
                this.$emit("change"); 
            } else {
                await changeDir(this.selectId, dirId).then((res) => {
                    if (res.data.success == true) {  
                        this.$emit("change");  
                        this.showMove = false;  
                        this.$showToast({msg: '操作成功！' });                
                    } 
                })
            }

        },          
    },
          
    
};


// WEBPACK FOOTER //
// ./src/mixin/mixinDoc.js